/* oxlint-disable unicorn/no-typeof-undefined -- import.meta may not exist in cross-runtime envs */
// available envs: prod; dev; and dev with TEST=true;
const env = {
  prod: false,
  dev: false,
  test: false,
  unsafeOverrideEnv: '',
}

// oxlint-disable-next-line typescript/ban-ts-comment, typescript/prefer-ts-expect-error -- cross-runtime env detection
// @ts-ignore
if (typeof process !== 'undefined' && process.env.NODE_ENV) {
  // oxlint-disable-next-line typescript/ban-ts-comment, typescript/prefer-ts-expect-error -- cross-runtime env detection
  // @ts-ignore
  env.test = process.env.NODE_ENV === 'test'
  // oxlint-disable-next-line typescript/ban-ts-comment, typescript/prefer-ts-expect-error -- cross-runtime env detection
  // @ts-ignore
  env.prod = process.env.NODE_ENV === 'production'
  // oxlint-disable-next-line typescript/ban-ts-comment, typescript/prefer-ts-expect-error -- cross-runtime env detection
  // @ts-ignore
  env.dev = !env.prod
  // oxlint-disable-next-line typescript/ban-ts-comment, typescript/prefer-ts-expect-error -- cross-runtime env detection
  // @ts-ignore
} else if (typeof import.meta !== 'undefined' && import.meta.env) {
  // oxlint-disable-next-line typescript/ban-ts-comment, typescript/prefer-ts-expect-error -- cross-runtime env detection
  // @ts-ignore
  env.test = import.meta.env.MODE === 'test'
  // oxlint-disable-next-line typescript/ban-ts-comment, typescript/prefer-ts-expect-error -- cross-runtime env detection
  // @ts-ignore
  env.prod = !!import.meta.env.PROD
  // oxlint-disable-next-line typescript/ban-ts-comment, typescript/prefer-ts-expect-error -- cross-runtime env detection
  // @ts-ignore
  env.dev = !env.prod
}

export const isDev = env.dev
export const isProd = env.prod
export const isTest = env.test

export const getUnsafeOverrideEnv = () => env.unsafeOverrideEnv
export const setUnsafeOverrideEnv = (newEnv: string) => {
  env.unsafeOverrideEnv = newEnv
}
